import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartComponent } from './cart.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [CartComponent],
    exports: [CartComponent],
    imports: [CommonModule, RouterModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class CartModule {}
